export class DateUtils {
  static formatDate(
    value: any,
    defaultValue: string = '-',
    locale?: string,
    options?: Intl.DateTimeFormatOptions
  ): string {
    if (!value) {
      return defaultValue;
    }

    try {
      const date = new Date(value);

      if (isNaN(date.getTime())) {
        return defaultValue;
      }

      if (options || locale) {
        return date.toLocaleDateString(locale, options);
      }

      return date.toLocaleString();
    } catch (error) {
      console.warn('Error formatting date:', error);
      return defaultValue;
    }
  }

  static format(value: any): string {
    return DateUtils.formatDate(value);
  }

  static formatDateOnly(value: any, defaultValue: string = '-'): string {
    return DateUtils.formatDate(value, defaultValue, undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  }

  static formatTimeOnly(value: any, defaultValue: string = '-'): string {
    return DateUtils.formatDate(value, defaultValue, undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }

  static formatDateOnlyUTC(value: any, defaultValue: string = '-'): string {
    return DateUtils.formatDate(value, defaultValue, undefined, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: 'UTC',
    });
  }

  static cleanApiDate(dateStr: string): string {
    if (!dateStr) return '';
    // Toma solo YYYY-MM-DD del string ISO
    const m = dateStr.match(/^\d{4}-\d{2}-\d{2}/);
    return m ? m[0] : '';
  }

  static todayString(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');
    const minute = String(now.getMinutes()).padStart(2, '0');
    const second = String(now.getSeconds()).padStart(2, '0');
    return `${year}${month}${day}${hour}${minute}${second}`;
  }

  // This method is used to convert a date to UTC without changing the time zone
  static parseToUTC(value: Date | string): Date {
    if (value instanceof Date) {
      return new Date(Date.UTC(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        value.getHours(),
        value.getMinutes(),
        value.getSeconds()
      ));
    }

    if (typeof value === 'string') {
      const [datePart, timePart] = value.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);

      return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    }

    return new Date(value);
  }
}
